export const mutations = {
  setType(state, payload) {
    state.content = payload;
  },
  setTimeLimit(state, payload) {
    const date = new Date();
    localStorage.setItem('timeLimit', payload);
    localStorage.setItem('timeDayMutation', date.getDay());
    state.time = payload;
  },
  setTimeVariable(state, payload) {
    state.timeIsSet = payload;
  },
  setAge(state, payload) {
    state.age = payload;
  },
  setLanguage(state, payload) {
    state.language = payload;
  },
  setSound(state, payload) {
    state.soundActive = payload;
  },
  setVideoPlaylist(state, payload) {
    state.playlist = payload;
  },
  setVideoIsPaused(state, payload) {
    state.videoIsPaused = payload;
  },
  setVideoList(state, payload) {
    state.videoList = payload;
  },
  displayAgeSetting(state, payload) {
    state.isAgeSettingDisplayed = payload;
  },
  ageSettingFor(state, payload) {
    state.ageSettingPath = payload;
  },
  setShowExpiration(state, payload) {
    state.showExpiration = payload;
  },
  setDisplayVideoLoader(state, payload) {
    state.displayVideoLoader = payload;
  },
  setDisplayLoader(state, payload) {
    state.displayLoader = payload;
  },
  setLoadingCards(state, payload) {
    state.loadingCards = payload;
  },
  setFocusLiveLink(state, payload) {
    state.focusLiveLink = payload;
  },
  setFocusKidjoWorldLink(state, payload) {
    state.focusKidjoWorldLink = payload;
  },
  setFocusSearchLink(state, payload) {
    state.focusSearchLink = payload;
  },
  setFocusSettings(state, payload) {
    state.focusSettings = payload;
  },
  setActiveHeaderBarNav(state, payload) {
    state.activeHeaderNav = payload;
  },
  setHideMobileCard(state, payload) {
    state.hideMobileCard = payload;
  },
  setLiveMode(state, payload) {
    state.activeLiveMode = payload;
  },
  setBannerState(state, payload) {
    state.activeBanner = payload;
  },
  setHeaderBannerState(state, payload) {
    state.activeHeaderBanner = payload;
  },
  setActiveSettingsCloseBtn(state, payload) {
    state.activSettingsCloseBtn = payload;
  },
  setNotificationVisibility(state, payload) {
    state.isNotificationVisible = Object.assign(state.isNotificationVisible, payload);
  }
};
